import { BaseResourceModel } from "../../models/base-resource.model";
import { Fatura } from "./fatura.model";
import { Liquidacao } from "./liquidacao.model";

enum FaturaTipo {
  TAXA = 'T',
  JUROS = 'J',
  ATT_MONETARIA = 'A'
}

export class LiquidacaoFaturaTipo extends BaseResourceModel {
  constructor(
    public liquidacao?: Liquidacao,
    public fatura?: Fatura,
    public tipo?: FaturaTipo
  ) {
    super();
  }

  static converteJson(json: any): LiquidacaoFaturaTipo {
    return Object.assign(new LiquidacaoFaturaTipo(), json);
  }
}